import React from 'react'
import { translate } from 'react-i18next'
import { compose, pure, withHandlers } from 'recompose'
import styles from './registrationFormWrapperComponent.scss'
import PropTypes from 'prop-types'
import RegistrationSchool from '../../forms/registrationSchool/registrationSchoolForm'
import RegistrationStudent from '../../forms/registrationStudent/registrationStudentForm'
import RegistrationPassword from '../../forms/registrationPassword/registrationPasswordForm'
import LoadingBar from '../loadingBar/loadingBarComponent'

export function RegistrationFormWrapper (props) {
  const { t } = props

  const nextPage = () => props.changeRegistrationPage(props.formPage + 1)
  const previousPage = () => props.changeRegistrationPage(props.formPage - 1)

  return (
    <div>
      <h1 className={styles.modalHeader}>
        {t('form:createAccount')}
        <small>
          {t('form:alreadyHaveAccount')}{' '}
          <button className={styles.linkButton} onClick={props.login}>
            <span>{t('form:signIn')}</span>
          </button>
        </small>
      </h1>
      {props.formPage === 1 && <RegistrationSchool onSubmit={nextPage} />}
      {props.formPage === 2 && (
        <RegistrationStudent previousPage={previousPage} onSubmit={nextPage} />
      )}
      {props.formPage === 3 && (
        <RegistrationPassword
          previousPage={previousPage}
          onSubmit={props.onSubmit}
        />
      )}

      <p />

      <LoadingBar percentDone={Math.round(props.formPage / 3 * 100)} />

      <p className={styles.noMargin}>
        <span style={{fontSize: '10pt'}}>
          {t('form:supportHavingTrouble')}
          <span style={{paddingLeft: '0.5em'}}>
            <a rel='noopener noreferrer' target='_blank' href='mailto:TexasOnCourseSupport@highered.texas.gov?subject=MapMyGrad Support Request'>{t('form:supportContactSupport')}</a>
          </span>
        </span>
      </p>
    </div>

  )
}
RegistrationFormWrapper.propTypes = {
  t: PropTypes.func.isRequired,
  formPage: PropTypes.number.isRequired,
  changeRegistrationPage: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  login: PropTypes.func.isRequired
}

const handlers = {
  login: props => () => {
    props.toggleRegistration()
    props.toggleLogin()
  }
}

export default compose(pure, translate(), withHandlers(handlers))(
  RegistrationFormWrapper
)



// WEBPACK FOOTER //
// ./src/components/registrationFormWrapper/registrationFormWrapperComponent.js